import type { IzziSaleOrder } from '@/domain/izzi';

/**
 * Muestra la acción de descarga cuando la orden está Fulfilled.
 * Los seriales se validan al generar el PDF (GET .../shipping-receipt);
 * el listado puede no incluir items[].serialNumbers aunque la orden sí los tenga.
 */
export const canDownloadShippingReceipt = (order: IzziSaleOrder): boolean =>
  order.fulfillmentStatus?.toLowerCase() === 'fulfilled';

export const getOrderNumber = (order: IzziSaleOrder): string =>
  order.orderNumber?.trim() || order.customerSo.trim();

export const parseContentDispositionFilename = (
  contentDisposition: string | undefined,
  fallback: string,
): string => {
  if (!contentDisposition) {
    return fallback;
  }

  const match = contentDisposition.match(/filename="?([^";]+)"?/i);
  return match?.[1]?.trim() || fallback;
};

export const mapShippingReceiptError = (message: string, status?: number): string => {
  const normalizedMessage = message.toLowerCase();

  if (normalizedMessage.includes('números de serie') || normalizedMessage.includes('numeros de serie')) {
    return 'La orden no tiene números de serie asignados';
  }

  if (normalizedMessage.includes('fulfilled')) {
    return 'La orden debe estar en estatus Fulfilled';
  }

  if (status === 404 || normalizedMessage.includes('no encontrada')) {
    return 'Orden no encontrada';
  }

  return 'Error al generar el acuse de envío';
};
